import axios from 'axios'

const product = 'TEXTANALYSISAPI'
const httpClient = axios.create({
  baseURL: process.env.VUE_APP_USAGE_BASE_URL,
  headers: { 'Content-Type': 'application/json' }
})

export default {
  setAccessToken (accessToken) {
    httpClient.defaults.headers = { Authorization: `Bearer ${accessToken}` }
  },
  intervalOptions: {
    MINUTE: 'minute',
    HOUR: 'hour',
    DAY: 'day',
    WEEK: 'week',
    MONTH: 'month',
    YEAR: 'year'
  },
  groupByOptions: {
    CLIENT_ID: 'client_id',
    CLIENT_IP: 'client_ip',
    LANGUAGE: 'language',
    PATH: 'path',
    STATUS_CODE: 'status_code'
  },
  async getNumberOfCalls (clientId, projectId, interval, from, to, groupBy) {
    try {
      const { data } = await httpClient.get(`/${clientId}/calls/timeSeries`, {
        params: {
          product,
          interval,
          from,
          to,
          groupBy,
          projectId
        }
      })
      // TODO: Handle malformed answers
      return data.result
    } catch (e) {
      console.error(`Can't get time series data. Error: ${e.message}`)
      throw new Error('Cannot get time series data')
    }
  },
  async getAverageResponseTime (clientId, projectId, interval, from, to) {
    try {
      const { data } = await httpClient.get(`/${clientId}/averageResponseTime/timeSeries`, {
        params: {
          product,
          interval,
          from,
          to,
          projectId
        }
      })
      // TODO: Handle malformed answers
      return data.result
    } catch (e) {
      console.error(`Cannot get average response time. Error: ${e.message}`)
      throw new Error('Cannot get average response time')
    }
  },
  async averageCharacterCount (clientId, projectId, from, to) {
    try {
      const { data } = await httpClient.get(`${clientId}/averageCharacterCount/timeSeries`, {
        params: {
          product,
          from,
          to,
          projectId
        }
      })
      return data.result
    } catch (e) {
      console.error(`Cannot get average character count. Error: ${e.message}`)
      throw new Error('Cannot get average character count')
    }
  },
  async characterCount (clientId, projectId, from, to) {
    try {
      const { data } = await httpClient.get(`${clientId}/characterCount/histogram`, {
        params: {
          product,
          from,
          to,
          projectId
        }
      })
      return data.result
    } catch (e) {
      console.error(`Cannot get character count. Error: ${e.message}`)
      throw new Error('Cannot get character count')
    }
  },

  /**
   *
   * @param {Number} clientId
   * @param {Number|undefined} projectId
   * @param {String|undefined} groupBy
   * @param {String} from
   * @param {String} to
   * @returns {Promise<Object>}
   */
  async getCallBreakdown (clientId, projectId, from, to, groupBy) {
    try {
      const { data } = await httpClient.get(`/${clientId}/calls`, {
        params: {
          product,
          groupBy,
          from,
          to,
          projectId
        }
      })
      // TODO: Handle malformed answers
      return data.result
    } catch (e) {
      console.error(`Cannot get call breakdown. Error: ${e.message}`)
      throw new Error('Cannot get call breakdown')
    }
  }
}
